import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import {
  Popup,
  Form
} from 'semantic-ui-react'

const BaseInputField = ({
  name,
  width,
  value,
  type,
  onChange,
  popupTxt,
  labelTxt,
  min,
  max,
  readOnly = false
}) => (
  <Form.Field width={R.isNil(width) ? null : width}>
    <Popup
      trigger={<label>{labelTxt}</label>}
      content={popupTxt}
    />
    <Form.Input
      readOnly={ readOnly }
      type={R.isNil(type) ? 'text' : type}
      min={R.isNil(min) ? null : min}
      max={R.isNil(max) ? null : max}
      name={name}
      value={value}
      onChange={onChange}
    />
  </Form.Field>
)

BaseInputField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date)
  ]),
  width: PropTypes.number,
  type: PropTypes.oneOf(['date', 'number', 'text']),
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  popupTxt: PropTypes.string.isRequired,
  labelTxt: PropTypes.string.isRequired,
  readOnly: PropTypes.bool
}

export default BaseInputField



// WEBPACK FOOTER //
// ./webAdmin/forms/baseInput.js